import { HotWheelsWishlist } from './hotwheels-wishlist';

export function HotWheelsWishlistPage() {
  return <HotWheelsWishlist />;
}

export default HotWheelsWishlistPage;